// extracted by mini-css-extract-plugin
export default {"Landing":"Landing_Landing__kOwXN","LandingText":"Landing_LandingText__mhhfa","LocButton":"Landing_LocButton__by-2S"};